module.exports = __webpack_public_path__ + "static/img/defaultAvatar.f8f033a2.png";